<template>
  <div class="home-content">
    <LanguageSwitcher v-if="!smallscreen" :languages="languages" />

    <div class="home-content__mid">
      <img
        :src="`${$baseUrl}images/logo-white.svg`"
        alt=""
        class="home-content__mid__logo"
      />

      <h1 class="home-content__mid__title">
        {{ title }}
        <div class="home-content__mid__title__sub">
          {{ subtitle }}
        </div>
      </h1>

      <SocialSharing
        class="home-content__mid__sharing"
        :smallscreen="smallscreen"
      />
    </div>

    <ButtonScroll @onScroll="scrollDown" />
  </div>
</template>

<script setup>
import { inject } from "vue";

import SocialSharing from "./SocialSharing.vue";
import ButtonScroll from "./ButtonScroll.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";

defineProps({
  title: String,
  subtitle: String,
  languages: {
    type: Array,
    default: () => [],
  },
  smallscreen: Boolean,
});

const $baseUrl = inject("$baseUrl");

function scrollDown() {
  const firstContentEl = document.getElementById("text-section-0");

  if (firstContentEl) {
    firstContentEl.scrollIntoView({ behavior: "smooth" });
  }
}
</script>

<style lang="scss" scoped>
.home-content {
  position: relative;
  background-color: var(--black-25);
  backdrop-filter: blur(5px);
  border-left: 1px solid var(--white-100);
  border-right: 1px solid var(--white-100);
  color: var(--white-100);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .desktop &,
  .large & {
    margin-left: var(--page-padding-h);
    width: var(--left-space);
    height: 100%;
    padding: 1.5rem 2rem 1.5rem 3.5vw;
    align-items: flex-start;
  }

  .tablet &,
  .mobile & {
  
    color: var(--white-100);
    background: linear-gradient(115.66deg, #025E6B 18.8%, #4FA1AD 84.48%);
    height: 50%;
    text-align: center;
    align-items: center;
    padding: 3vh 1.5rem 2vh 1.5rem;
    .home-content__mid {
      &__logo {
      margin-bottom: toRem(15);
    }
    }
  }

  .mobile & {
    padding: 3vh 1.5rem;
  }

  &__mid {
    &__logo {
      margin-bottom: toRem(35);
    }

    &__title {
      @include h-h-1;

      max-width: toRem(240);

      &__sub {
        @include dida-m;

        font-family: "Open Sans";
        margin-top: 0.25rem;

        .desktop &,
        .large & {
          margin-bottom: toRem(35);
        }

        .mobile &,
        .tablet & {
          margin-bottom: 1.25rem;
        }
      }
    }

    &__sharing {
      margin-bottom: 0.5rem;
    }

    .tablet &,
    .mobile & {
      &__sharing {
        margin-top: toRem(35);
      }
    }
  }
}
</style>
